module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Valbirse_COA-5bb2107d3f088216043e1ee524e67ada.svg";